<template>
  <div class="how-class">
    <div class="ha-des">
      <p class="black">问：如何获得可币？</p>
      <p>答：通过以下几种途径可以获得可币：</p>
      <ul class="list">
          <li>做作业/做练习：在APP内完成练习或作业可以获得可币，获得的可币数量与作业或练习的分数有关，比如作业的<60分，会获得1~2个可币，而作业分数>80分，就可以得到22~30个可币。分数越高，得到的可币数量越多；</li>
          <li>配音：完成配音也可获得可币奖励，获得的可币数量与配音等级有关，等级越高，可币数量越多；</li>
          <li>分享：每日首次分享作业或练习；</li>
        <li>订正错题：订正错题本或错题报告的错题；</li>
        <li>学情分析：完成学情分析中的指导练习。</li>
      </ul>
      <p class="black">问：如何获得勋章？</p>
      <p>答：勋章共有四个系列，分别为“持之以恒”、“准时完成”、“在线学习”、“表演戏精”。每个系列的勋章分别设计了不同的学习任务，用户完成相应的任务后，就可获得对应的勋章。比如“持之以恒”系列的“绿色蜜蜂”勋章，获得该勋章需要用户累计七天，每天在APP内完成任一学习任务（比如练习/作业/考试/视频播放）。
勋章具体获取规则可以进入“我的”页面，点击【我的勋章】，点击勋章就可以看到对应的获取规则。</p>     
    <div class="ha-img">
      <img src="./img/medal.png" alt="">
    </div>
  </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-class {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p{
        margin: p2r(10) 0;
      }
      a{
        color: $blue;
      }
      .list{
          list-style-type: disc;
          padding-left: 20px;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title='如何获得可币和勋章? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('如何获得可币和勋章')
    },
    components: {}
  }
</script>
